/**
 * Use Navigation Guard Hook
 *
 * Custom hook for monitoring unsaved changes state and managing navigation warnings.
 *
 * @since 1.0.0
 */

import { useEffect, useState } from 'react';

import { subscribeToUnsavedChanges } from '../../utils';

/**
 * Hook for monitoring navigation guard state
 *
 * @since 1.0.0
 *
 * @return Object with unsaved changes state.
 */
export const useNavigationGuard = () => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToUnsavedChanges((hasChanges) => {
      setHasUnsavedChanges(hasChanges);
    });

    return unsubscribe;
  }, []);

  return {
    hasUnsavedChanges,
  };
};
